import "dotenv/config";
import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

export const env = createEnv({
	server: {
		DATABASE_URL: z.string().min(1),
		TEST_DATABASE_URL: z.string().optional(),
		BETTER_AUTH_SECRET: z.string().min(32),
		BETTER_AUTH_URL: z.url(),
		CORS_ORIGIN: z.url(),
		SMS_OTP_WEBHOOK_URL: z.url().optional(),
		SMS_OTP_WEBHOOK_TOKEN: z.string().optional(),
		GOOGLE_OAUTH_CLIENT_ID: z.string().optional(),
		GOOGLE_OAUTH_CLIENT_SECRET: z.string().optional(),
		LOG_OTP: z.enum(["true", "false"]).optional(),
		NODE_ENV: z
			.enum(["development", "production", "test"])
			.default("development"),
		FIREBASE_SERVICE_ACCOUNT_KEY: z.string().optional(),
		FIREBASE_SERVICE_ACCOUNT_KEY_BASE64: z.string().optional(),
		RESEND_API_KEY: z.string().optional(),
		RESEND_DEFAULT_FROM: z.string().optional(),
		MSG91_SMS_AUTH_KEY: z.string().optional(),
		MSG91_SENDER_ID: z.string().optional(),
		MSG91_WHATSAPP_AUTH_KEY: z.string().optional(),
		MSG91_WHATSAPP_NUMBER: z.string().optional(),
		R2_ACCOUNT_ID: z.string().min(1).optional(),
		R2_ACCESS_KEY_ID: z.string().min(1).optional(),
		R2_SECRET_ACCESS_KEY: z.string().min(1).optional(),
		R2_BUCKET_NAME: z.string().min(1).optional(),
		R2_PUBLIC_URL: z.url().optional(),
	},
	runtimeEnv: process.env,
	emptyStringAsUndefined: true,
});
